import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  flex-flow: column;
  width: 100%;
`;

export const boxBaseStyle = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  border-radius: ${theme.borderRadius.small};
  background-color: ${theme.colors.neutral5};
  cursor: pointer;
  padding: ${theme.spacing(2)};
  font-size: 14px;
  margin-bottom: ${theme.spacing(2)};
`;

export const boxDefaultStyle = css`
  border: dashed ${theme.colors.neutral30} 1px;
`;

export const boxDraggingStyle = css`
  border: solid ${theme.colors.primary50} 1px;
`;

export const iconStyle = css`
  transform: rotate(90deg);
`;

export const buttonStyle = css`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  word-wrap: none;
  width: max-content;
  padding: ${theme.spacing(1.25, 2)};
  border: 1px solid ${theme.colors.neutral50};
  box-sizing: border-box;
  border-radius: ${theme.spacing(0.5)};
  margin-top: ${theme.spacing(2.5)};
  cursor: pointer;
`;

export const imagePreviewContainerStyle = css`
  display: flex;
  flex-flow: row wrap;
  padding-bottom: ${theme.spacing(1.5)};
`;

export const imagePreviewStyle = css`
  display: flex;
  flex-flow: column;
  align-content: center;
  max-width: 100px;
  margin-left: ${theme.spacing(3)};
`;

export const imagePreviewTextStyle = css`
  height: 100%;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: auto;
`;

export const errorTextStyle = css`
  color: ${theme.colors.text.critical};
`;
